import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import CustomSearchBox from '../../../../components/mazraeKit/customSearchBox';
import MainFooter from '../../../../components/mazraeKit/footers/footerMain';
import CustomHeader from '../../../../components/mazraeKit/headers/homeHeader';
import NoData from '../../../../components/noData';
import SpinnerLoading from '../../../../components/SpinnerLoading';
import useGetListBrandSummery from '../../../../services/hookService/getListBrandSummery/useGetListBrandSummery';
import useDebounce from '../../../../utilities/hooks/useDebounce/useDebounce';
import useInfiniteScroll from '../../../../utilities/hooks/useInfiniteScroll';
import BrandItem from '../selectedBrands/BrandItem';
import BrandItemSkeleton from '../selectedBrands/BrandItemSkeleton';

const SelectedBrandsPage = () => {
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState('');
  const debouncedValue = useDebounce<string>(inputValue, 1000);

  const {data, isLoading, fetchNextPage, hasNextPage, isFetching} =
    useGetListBrandSummery({pageSize: 28, search: debouncedValue});

  const loaderRef = useInfiniteScroll({
    isLoading,
    fetchNextPage,
    isFetchingNextPage: isFetching,
    hasNextPage,
  });

  return (
    <div className="flex relative flex-col w-full h-screen">
      <div>
        <CustomHeader
          canScroll={true}
          title="برندهای منتخب"
          preIcon="icon-nameArrow---Right"
          isActiveRightIcon
          onClick={() => navigate('/home')}
        />
      </div>

      <div className="flex overflow-y-auto flex-col gap-3 p-4 mb-10 w-full">
        <CustomSearchBox
          placeholder="جستجو"
          type="text"
          value={inputValue}
          inputCustomClass="!pr-2"
          preIcon="icon-nameSearch"
          onChange={e => setInputValue(e.target.value)}
          {...{inputValue, setInputValue}}
        />

        {!isLoading && data?.length === 0 ? (
          <div className="mx-auto mt-52">
            <NoData text="موردی پیدا نشد" />
          </div>
        ) : (
          <div className="grid grid-cols-4 gap-4 mt-3">
            {isLoading
              ? Array.from({length: 28}, (_, index) => (
                  <BrandItemSkeleton key={index} />
                ))
              : data?.map(item => (
                  <BrandItem
                    key={item.id}
                    data={item}
                    textColor="text-gray-800"
                    onClick={() => navigate(`/brand/${item.id}`)}
                  />
                ))}
            <div ref={loaderRef} />
          </div>
        )}
        {!isLoading && isFetching && (
          <SpinnerLoading className="mx-auto my-4" />
        )}
      </div>

      <div className="fixed right-0 bottom-0 left-0">
        <MainFooter />
      </div>
    </div>
  );
};

export default SelectedBrandsPage;
